import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "price",
  pure: true,
})
export class PricePipe implements PipeTransform {
  constructor(
    private decimalPipe: DecimalPipe,
    private translateService: TranslateService,
  ) {}

  transform(
    salesPrice: number,
    isMonthly = false,
    quantity: number = 1,
  ): string {
    let price = salesPrice * quantity;

    if (isMonthly) {
      price = Math.round(price / 12);
    } else {
      price = Math.ceil(price);
    }

    const priceString = `${this.decimalPipe.transform(
      price,
      "",
      "sv-SE",
    )} ${this.translateService.instant("price.kr")}`;

    if (!isMonthly) {
      return priceString;
    }
    if (salesPrice * quantity < 500) {
      return "";
    }
    return `${priceString} / ${this.translateService.instant("price.month")}`;
  }
}
